<template>
  <div class="product-accordion m-top-0">
    <div
      v-if="applicazioni"
      class="product-accordion__item"
      @click="toggleAccordion('applicazioni')"
    >
      <div class="product-accordion__header">
        <h2 class="title-base4" v-html="$t('common.applicazioni')" />
        <img
          class="icon"
          :class="{ 'rotate-icon': isOpen('applicazioni') }"
          src="@/assets/img/ico/arrow-mobile.svg?url"
          alt="Icon"
        />
      </div>
      <div
        class="product-accordion__body text-editorial"
        v-show="isOpen('applicazioni')"
      >
        <div class="text-medium" v-html="applicazioni" />
      </div>
    </div>
    <div
      v-if="specifiche"
      class="product-accordion__item"
      @click="toggleAccordion('specifiche')"
    >
      <div class="product-accordion__header">
        <h2 class="title-base4" v-html="$t('common.specificheTecniche')" />
        <img
          class="icon"
          :class="{ 'rotate-icon': isOpen('specifiche') }"
          src="@/assets/img/ico/arrow-mobile.svg?url"
          alt="Icon"
        />
      </div>
      <div
        class="product-accordion__body text-editorial"
        v-show="isOpen('specifiche')"
      >
        <div class="text-medium" v-html="specifiche" />
      </div>
    </div>
    <div
      v-if="preparazione && preparazione.length"
      class="product-accordion__item"
      @click="toggleAccordion('preparazione')"
    >
      <div class="product-accordion__header">
        <h2 class="title-base4" v-html="$t('common.preparazione')" />
        <img
          class="icon"
          :class="{ 'rotate-icon': isOpen('preparazione') }"
          src="@/assets/img/ico/arrow-mobile.svg?url"
          alt="Icon"
        />
      </div>
      <div
        class="product-accordion__body preparazione text-editorial"
        v-show="isOpen('preparazione')"
      >
        <div
          v-for="(item, index) in preparazione"
          :key="index"
          class="text-medium reverse-underline-hover"
        >
          <NuxtLink
            :to="
              localePath({
                name: 'modalita-d-uso-slug',
                params: { slug: item.slug },
              })
            "
            >{{ item.title }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  applicazioni: {
    type: String,
  },
  specifiche: {
    type: String,
  },
  preparazione: {
    type: Array,
  },
})

const openItem = ref(null)
const toggleAccordion = (item) => {
  openItem.value = openItem.value === item ? null : item
}
const isOpen = (item) => {
  return openItem.value === item
}
</script>

<script>
export default {
  name: 'ProductAccordion',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
